import { apiConfig } from '../../services/apiConfig';
import { AMLS_COMMON } from './globalConstants';

const TOKEN_ID = (localStorage && localStorage.getItem('id_token')) || '';
const PRODUCT_ID = (localStorage && localStorage.getItem('productId')) || '';

const BASE_URL = new URL(apiConfig.serviceApi);
const API_NAMESPACE = 'crs';

export const CRS_CONSTANTS = {
  AMLS_COMMON,
  CRS_BASE_URL: `${apiConfig.serviceApi}/${API_NAMESPACE}`,
  HTTP_HEADERS: Object.freeze({
    'Content-Type': 'application/json',
    'X-HTTP-Method-Override': 'PUT',
    // Authorization: `${TOKEN_ID}`,
    Authorization: `Bearer ${TOKEN_ID}`,
    ProductId: PRODUCT_ID
  }),
  GET_SUCCESS_DATA: 'getSuccessData',
  GET_FAILURE_DATA: 'getFailData',
  GET_DATA: 'getData',
  POST_DATA: 'postData'
};

export const CRS_TAB_LIST = ['Customer Listing', 'Customer Details'];
export const CRS_TAB_PAGEID_LIST = [
  'CRS_CUSTOMER_LISTING',
  'CRS_CUSTOMER_DETAILS'
];
export const CRS_EXPLAINABILITY_TAB_ORDER = {
  STATIC: 0,
  REGULATORY: 1,
  'INCONSISTENCY BEHAVIOUR': 2,
  'HISTORICAL BEHAVIOUR': 3
};

export const CRS_CLUSTER_RISK_INDICATOR_TAB = [
  'CUSTOMER',
  'TRANSACTIONS',
  'HISTORICAL RISK'
];

export const ALERT_SOURCES = {
  0: 'Transaction Monitoring',
  1: 'Transaction Monitoring',
  2: 'Name Screening',
  3: 'Name Screening',
  4: 'Transaction Screening',
  5: 'Customer Risk Scoring',
  6: 'Transaction Monitoring',
  7: 'Name Screening',
  8: 'Transaction Monitoring',
  9: 'Transaction Screening',
  10: 'Customer Risk Scoring',
  11: 'Customer Risk Scoring',
  12: 'Customer Risk Scoring',
  13: 'Transaction Screening',
  14: 'Customer Risk Scoring',
  15: 'Manual Case',
  16: 'Prospect Screening',
  17: 'Risk Scoring',
  18: 'Prospect Screening',
  19: 'Risk Scoring',
  20: 'Fraud',
  21: 'Fraud'
};

export const ALERT_REASON = {
  5: 'First Time Risk',
  10: 'Periodic Review',
  11: 'Change In Risk',
  12: 'Others',
  14: 'Prioritise Alert'
};
